import React from 'react';
import { withTheme } from '@rneui/themed';
import { BookmarkButton } from '../bookmark';
import { FavoriteButton } from '../content';
import { Row } from '../elements';
import { SleepTimer, TrackSettings } from './';
export const UnthemedButtonBar = ({ content, iconStyle, containerStyle, }) => {
    return (React.createElement(Row, { style: containerStyle },
        React.createElement(FavoriteButton, { item: content, iconStyle: iconStyle }),
        React.createElement(SleepTimer, { iconStyle: iconStyle, buttonStyle: { padding: 10 } }),
        React.createElement(BookmarkButton, { item: content, iconStyle: iconStyle }),
        React.createElement(TrackSettings, { iconStyle: iconStyle, buttonStyle: { padding: 10 } })));
};
export const ButtonBar = withTheme(UnthemedButtonBar, 'ButtonBar');
//# sourceMappingURL=ButtonBar.js.map